import { useEffect} from 'react'
import { useMap } from 'react-leaflet'
import L  from 'leaflet'

const FlyTo = (props) => {
    const { location, resetLocation } = props
    const map = useMap();
    
    useEffect(() => {
        if(location?.location?.lat && location?.location?.long){
          const lat = Number(location.location.lat);
          const long = Number(location.location.long);
          const zoom = location.zoom || 12;

          if (!isNaN(lat) && !isNaN(long) && lat !== 0 && long !== 0) {
            map.flyTo(L.latLng(lat, long), zoom);
            resetLocation({});
          } else {
            console.error('Invalid coordinates:', { lat: location.location.lat, long: location.location.long });
          }
        }
    }, [location])
    return null;
}

export default FlyTo;